import { hasYesOrNo } from 'models/validate';
import { ValidateJSModel } from 'forms/shared/types';
import { LegalAssociationsViolenceModel } from './types';
import { legalAssociationsViolenceItemValidator } from './validators/item';

const legalAssociationsViolenceValidator: ValidateJSModel<LegalAssociationsViolenceModel> = {
  HasViolence: { presence: true, hasValue: { validator: hasYesOrNo } },

  List: (value, attributes) => {
    if (attributes?.HasViolence?.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: legalAssociationsViolenceItemValidator },
      };
    }
    return {};
  },
};

export default legalAssociationsViolenceValidator;
